<template>
  <section class="produccion-item">
    <b-card>
      <h4 class="mb-1">{{ resolvedTitle }}</h4>
      <p class="mb-0 text-muted">Seccion en construccion.</p>
    </b-card>
  </section>
</template>

<script>
export default {
  name: "ProduccionItem",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  computed: {
    resolvedTitle() {
      return this.title || this.$route?.meta?.pageTitle || "Produccion";
    },
  },
};
</script>

<style scoped>
.produccion-item {
  padding: 1rem;
}
</style>
